export default __webpack_public_path__ + "static/media/connectionOn.d845442b.svg";